import XJJSBridge from 'tools/JsBridge';
import { is58App, isHaojieApp, isApp, isHaojieSDK, is58APPVersionGreaterThan, isIos, isGanjiApp } from './UA';
const WBAPP = window.WBAPP;

/**
 * 设置title 在58同城app、58好借app、浏览器
 */
const setTitle = (title: string | undefined = '58好借'): void => {
    document.title = title;
    (isApp() || isGanjiApp()) && XJJSBridge.invoke('set_title', { title });
};

/**
 * 返回webType 由于58app在9.3版本后用的wkWebview  之前用的uiWebview； 好借app用的是uiWebview; 非app中返回什么值都无所谓 用不着这个字段
 */
const getWebType = (): string => is58APPVersionGreaterThan('9.3.0') ? 'wkWebview' : 'uiWebview';

/**
 * 页面跳转  如果在APP或sdk中调用native方法跳转页面，否则href跳转页面;通常用于从好借跳转到其他产品 例如快借；或者是跳转到活动页等其他html页面。
 * 入参：跳转的url
 * TODO: 后续可以参考快借里的pageTransfer 以及首页调用的PageFrame方法整合到一个方法
 */
const pageJump = (url: string,isfinish?:boolean): void => {
    if (isApp() || isHaojieSDK() || isGanjiApp()) {
        XJJSBridge.invoke('pagetrans', {
            action: 'pagetrans',
            tradeline: 'core',
            content: {
                url,
                pagetype: 'common',
                isfinish:isfinish?isfinish:false,
                webType: getWebType()
            }
        });
    } else {
        window.location.href = url;
    }
}

/**
 * 返回平台首页
 * 说明: 点击确定按钮需要返回到平台首页：如果是好借app中的话，平台首页用的是native的页面，所以跳转到好借首页的时候是打开webview，所以好借app中直接关闭webview就行了
 * 如果是非好借app中，平台首页是用的h5的页面，跳转到好借首页的逻辑是：如果是58同城app中，是会通过打开新的webveiw来跳转到好借首页的；其他情况下用的window.location.href跳转的
 * 所以在sdk中直接用history.go(-1)就可以跳转。58同城app的话，由于jsBridge中提供的方法和好借app不一致，所以单独处理进行webview的关闭
 */
const backAnzuHome = (): void => {
    if (isHaojieApp()) {
        XJJSBridge.invoke('close_webview', {refresh: true});
        return;
    }
    if (is58App()) {
        XJJSBridge.action.goback(true);
        return;
    }
    window.history.go(-1);
}

// ios: 跳转页面后点击返回再回来，不会触发页面刷新，也不会触发componentDidMount等生命周期，一直保持着跳走之前的状态。
// 目前测到ios13.3.1系统没这个问题 但是14和15都有这个问题  安卓没发现这个问题  故以下方法解决此问题
function iphoneBackRefresh() {
    if (isIos()) {
        window.onpageshow = function(event) {
            //页面是从缓存中获取的数据||是通过浏览器后退来到该页面
            if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
		        window.location.reload();
	        }
        };
    }
}

// 监听返回 并判断是否要显示挽留弹窗 只有同城app和sdk有device_event这个方法
const listenBack = callback => {
    if ((is58App() || isHaojieSDK())) {
        XJJSBridge.invoke('device_event', {
            type: 'goback', // goback:页面回退时触发；pageshow:页面展示时触发
        }, callback);
    }
}

// 监听返回事件重置 58同城和sdk的处理还不同x
const resetGoBack = callback => {
    if (is58App()) {
        window.XJJSBridge.invoke('device_event', {
            type: 'goback', // goback:页面回退时触发；pageshow:页面展示时触发
        }, callback);
    } else if (isHaojieSDK()) {
        window.XJJSBridge.invoke('device_event', { methodName: null });
    }
}

// 返回首页 因为从首页跳转到授信流程用的是history.push方法  所以为了避免在首页点返回回到的还是首页 在58同城和好借app中 这里要用goBack即可
// h5页面因为接了face++ 是用href和第三方页面互跳的 所以返回的话流程太长了 需要replace替换到首页
// 赶集虽然是接的face++的人脸 但是赶集在首页跳转验二和人脸引导页的时候是新开webview 从人脸引导页跳转face++的时候是关闭当前webview并新开webview打开face++页面的  face++回调到人脸结果页的时候也是关闭当前webview并新开webview来打开人脸结果页 所以用goBack关闭当前webview就能回首页
const accreditBackHome = history => {
    if (isApp() || isHaojieSDK()) {
        history.goBack();
    } else if (isGanjiApp()) {
        window.XJJSBridge.action.goback(true);
    } else {
        history.replace('/home');
    }
}

/**
 * 拦截ios测滑
 * @param callback 
 */
const sideTouchHandler = callback => {
    if (is58App() && isIos()) {
        XJJSBridge.invoke('toggle_gesture', {
            cmd: 'off',
            closeTwiceDirectBack: true,
            edge_paning: true,
            webview_paning: 'off'
        }, callback);
    }
}

/**
 * ios侧滑-webview goback
 */
const sideToucGoBackhHandler = () => {
    if (is58App() && isIos()) {
        XJJSBridge.invoke('toggle_gesture', {
            cmd: 'on',
            edge_paning: false,
            webview_paning: 'on'
        },);
    }
}

const globalGoback = () => { 
    is58App() && WBAPP.action.goback(false);
}

export {
    setTitle,
    getWebType,
    pageJump,
    backAnzuHome,
    iphoneBackRefresh,
    listenBack,
    resetGoBack,
    accreditBackHome,
    sideTouchHandler,
    sideToucGoBackhHandler,
    globalGoback,
}